//eslint-disable-next-line
import axios from "axios";

const base = process.env.VUE_APP_API_BASEURL;

export const state = {
    app_data: null,
    step_data: null,
};

export const getters = {
    app(state) {
        if (state.app_data) {
            return state.app_data;
        }
        return null;
    },
}

export const mutations = {
    setAppData(state, payload){
        state.app_data = payload;
    },
    setStepData(state, payload){
        state.step_data = payload;
    },
    resetStore(state, payload){
        state.app_data = payload;
        state.step_data = payload;
    }
};

export const actions = {
    loadAppData({commit}){
        return new Promise((resolve, reject)=>{
            axios.get( base + 'api/licenseapp/getdata')
            .then((response)=>{
                console.log('App Data', response.data);
                commit('setAppData', response.data);
                resolve();
            })
            .catch(()=>{
                reject();
            })
        })
    },
    loadStepData({commit}, step_id){
        return new Promise((resolve, reject)=>{
            axios.get( base + 'api/licenseapp/stepdata/'+ step_id)
            .then((response)=>{
                console.log('Step Data', response.data);
                let data = response.data;
                if(data.custom_render_component_name == null){
                    data.custom_render_component_name = 'Simple.vue';
                }
                commit('setStepData', data);
                resolve();
            })
            .catch((e)=>{
                console.log(e)
                reject();
            })
        })
    },

    //eslint-disable-next-line
    saveFormData({}, form_data){
        return new Promise((resolve, reject) => {
            axios.post( base + 'api/licenseapp/saveformdata/', form_data)
            .then(()=>{
                resolve();
            })
            .catch(error => {
                console.log('Error saving form data.', error);
                reject();
            })
        })
    },

    //eslint-disable-next-line
    getDownloadLink({}, data){ //item_type, item_id
        return new Promise((resolve, reject) => {
            axios.post( base + 'api/licenseapp/getdownloadlink', data)
            .then((response)=>{
                resolve(response.data.temp_url);
            })
            .catch(error => {
                console.log('Error getting download.', error);
                reject();
            })
        })
    },

    //eslint-disable-next-line
    requestStepApproval({}, step_id){
        return new Promise((resolve, reject) => {
            axios.post( base + 'api/licenseapp/requestapproval', {step_id: step_id})
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },




    /*Comments */
    /*eslint-disable-next-line */
    saveComment({}, params){
        return new Promise((resolve, reject) => {
            axios.post( base + 'api/licenseapp/savestepcomment', params)
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },

    /*eslint-disable-next-line */
    markAction({}, params){
        return new Promise((resolve, reject) => {
            axios.post( base + 'api/licenseapp/trackstepaction', params)
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },

    /*eslint-disable-next-line */
    deleteComment({}, params){
        return new Promise((resolve, reject) => {
            axios.post( base + 'api/licenseapp/deletestepcomment', params)
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },

    clearAll({commit}){
        return new Promise((resolve) => {
            commit('resetStore', null);
            resolve();
        })
    },


};
